import {
    HttpResponse,
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { LoaderService } from './loader.service';
import { ToastService } from '../service/toast.service';
import { Injectable } from '@angular/core';
import { JwtDecodeService } from './login/others/JWTDecodeService';
import { LocalStorageService } from './LocalStorageService';
import { AppConfigService } from '../service/Configuration/app-config.service';
import { catchError, tap, finalize } from 'rxjs/operators';
import { SubscriptionServiceService } from '../service/SubscriptionService/subscription-service.service';

@Injectable()
export class LoaderInterceptor {
    private requests: HttpRequest<any>[] = [];

    constructor(
        private loaderService: LoaderService,
        private toastService: ToastService,
        private tokenVerify: JwtDecodeService,
        private persistenceService: LocalStorageService,
        private appConfig: AppConfigService,
        private subscriptionService: SubscriptionServiceService
    ) { }

    private removeRequest(req: HttpRequest<any>) {
        const index = this.requests.indexOf(req);
        if (index !== -1) {
            this.requests.splice(index, 1);
        }
        this.loaderService.isLoading.next(this.requests.length > 0);
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        // Skip token check for assets
        if (req.url.startsWith('/assets/')) {
            return next.handle(req);
        }

        // Extract access token from redirected URL (OAuth)
        if (window.location.href.includes('access_token=')) {
            const url = new URL(window.location.href);
            const value = url.searchParams.get('access_token');
            if (value) this.persistenceService.set('access_token', value);
        }

        const token = this.persistenceService.get('access_token');
        // console.log("ID Token 111111111111111: " + token)
        const url = new URL(window.location.href);
        url.searchParams.delete('access_token');
        url.searchParams.delete('refresh_token');
        url.searchParams.delete('id_token');
        window.history.replaceState({}, document.title, url.toString());
        // Token validation
        if (!this.tokenVerify.isTokenValid(token)) {

            this.persistenceService.set('access_token', 'NA');
            this.persistenceService.set('refresh_token', 'NA');

            const allEmails = this.persistenceService.get('allEMails');
            const cnt = allEmails ? allEmails.split(',').length : 1;

            const redirectUrl =
                `${this.appConfig.setting.loginLogoutUrl}signin?cnt=${cnt}&source=${window.location.origin}/`;

            // Soft redirect (let Angular finish current tasks)
            setTimeout(() => {
                window.location.href = redirectUrl;
            }, 150);

            return throwError(() => ({
                status: 401,
                redirectUrl,
                message: 'Token expired or invalid'
            }));
        }

        // Add request to loader queue
        this.requests.push(req);
        this.loaderService.isLoading.next(true);

        return next.handle(req).pipe(

            tap(event => {
                if (event instanceof HttpResponse) {

                    // this.subscriptionService
                    //     .setSubscription("U123");

                    const subscriptionStatus =
                        event.headers.get('X-Mobitrix-Subscription');

                    if (subscriptionStatus) {
                        console.log(
                            'Mobitrix Subscription:',
                            subscriptionStatus
                        );

                        this.subscriptionService
                            .setSubscription(subscriptionStatus);
                    }

                    this.removeRequest(req);
                }
            }),

            catchError((err: HttpErrorResponse) => {
                this.removeRequest(req);

                // FULL ABSOLUTE API URL
                const fullApiUrl = req.url.startsWith('http')
                    ? req.urlWithParams
                    : `${location.origin}${req.urlWithParams}`;

                const status = err?.error?.status ?? err?.status ?? 'unknown';
                const statusText = err?.statusText ?? 'unknown';
                const message = err?.error?.message ?? err?.message ?? 'Unknown error';

                // --- NEW: REQUEST PAYLOAD DETAILS ---
                const requestPayload = req.body;
                const requestMethod = req.method;
                const requestHeaders = req.headers.keys().map(k => ({
                    key: k,
                    value: req.headers.get(k)
                }));

                console.error('🔥🔥🔥 API ERROR DETAILS 🔥🔥🔥');
                console.error('🌐 FULL API URL:', fullApiUrl);
                console.error('📡 METHOD:', requestMethod);
                console.error('📦 PAYLOAD:', requestPayload);
                console.error('🧾 HEADERS:', requestHeaders);
                console.error('🪪 Token:', token);
                console.error('📍 Window URL:', window.location.href);
                console.error('➡️ Status==:', status);
                console.error('➡️ Status Text==:', statusText);
                console.error('➡️ Message:', message);
                console.error('➡️ Backend URL (from error):', err?.url);
                console.error('🐞 Full error object:', err);

                // Toast
                if (status === 503) {
                    this.toastService.showWarningToast('Please, try after sometime');
                } else if (status !== 500 && message !== 'No message available') {
                    this.toastService.showErrorToast(message);
                } else {
                    this.toastService.showErrorToast('Oops! Something went wrong.');
                }

                return throwError(() => err);
            }),



            finalize(() => {
                // ALWAYS ensure loader is updated
                this.removeRequest(req);
            })
        );
    }
}
